

class Keys {

    static getAPIKey() {
        return 'AIzaSyBdvHpEeml7CKVUmqW_vHM0Oprvjuhur-o';
    }
    
    static getClientID() {
        return '286520596166-kcoq2cmrbd0cejleemk2viuq6rguivhj.apps.googleusercontent.com';
    }

} export default Keys;